module.exports = __webpack_public_path__ + "static/media/awardsbackgroundmobile.4553d189.jpg";